"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderStartups = exports.renderDragons = void 0;
var _react = _interopRequireDefault(require("react"));
var _basicStyledText = _interopRequireDefault(require("../basicStyledText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const dragonsTitle = {
  "text": "Dragons: ",
  "bold": true,
  "italic": false
};
const startupsTitle = {
  "text": "Startups: ",
  "bold": true,
  "italic": false
};
const renderDragons = dragons => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-text__xs"
  }, /*#__PURE__*/_react.default.createElement(_basicStyledText.default, {
    item: dragonsTitle
  }), dragons.map(dragonObject => {
    return /*#__PURE__*/_react.default.createElement("p", {
      key: dragonObject.id,
      className: "con-text__xs"
    }, dragonObject.name);
  }));
};
exports.renderDragons = renderDragons;
const renderStartups = startups => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-text__xs"
  }, /*#__PURE__*/_react.default.createElement(_basicStyledText.default, {
    item: startupsTitle
  }), startups.map(startupObject => {
    return /*#__PURE__*/_react.default.createElement("p", {
      key: startupObject.id,
      className: "con-text__xs"
    }, startupObject.name);
  }));
};
exports.renderStartups = renderStartups;